export class IfcExpressionBuiltinConfigException extends Error {
  constructor(message: string) {
    super(message);
  }
}
